import { useAPIProviderRegisterHotKeys } from '../../../../common/hooks/use-api-provider';
import type { RegisterHotkeysArgsT, RegisterHotkeysResultT } from '../../../../common/types/types';
export default function useShortcut() {
  const apiRegisterHotKeys = useAPIProviderRegisterHotKeys();
  const fallback = (_args: RegisterHotkeysArgsT): RegisterHotkeysResultT => ({
    errors: [],
    removeHotKeys: () => {}
  });
  return {
    registerHotKeys: apiRegisterHotKeys ?? fallback
  };
}